"use client";
import { jsxs as n, jsx as e, Fragment as A } from "react/jsx-runtime";
import { Check as z, Clipboard as W, Search as q, FileSpreadsheet as B, FileJson as X, ChevronUp as Z, ChevronDown as K, ChevronLeft as Q, ChevronRight as _, X as V } from "lucide-react";
import { useState as x, useEffect as Y, useMemo as T } from "react";
import { c as m, G as J } from "./card-BC9t8iAS.js";
function P(s) {
  const l = Math.floor(((/* @__PURE__ */ new Date()).getTime() - s.getTime()) / 1e3);
  return l < 5 ? "just now" : l < 60 ? `${String(l)}s ago` : l < 3600 ? `${String(Math.floor(l / 60))}m ago` : l < 86400 ? `${String(Math.floor(l / 3600))}h ago` : l < 604800 ? `${String(Math.floor(l / 86400))}d ago` : s.toLocaleDateString();
}
function F({ value: s }) {
  const [d, l] = x(!1);
  return /* @__PURE__ */ e(
    "button",
    {
      onClick: (w) => {
        w.stopPropagation(), navigator.clipboard.writeText(s).then(() => {
          l(!0), setTimeout(() => {
            l(!1);
          }, 2e3);
        }).catch(() => {
          const u = document.createElement("textarea");
          u.value = s, document.body.appendChild(u), u.select();
          try {
            document.execCommand("copy");
          } catch {
          }
          document.body.removeChild(u), l(!0), setTimeout(() => {
            l(!1);
          }, 2e3);
        });
      },
      className: m(
        "p-1 rounded transition-colors flex-shrink-0",
        d ? "text-green-500" : "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
      ),
      title: d ? "Copied!" : "Copy to clipboard",
      children: d ? /* @__PURE__ */ e(z, { className: "w-3 h-3" }) : /* @__PURE__ */ e(W, { className: "w-3 h-3" })
    }
  );
}
function ee({
  timestamp: s,
  className: d,
  rawValue: l,
  forceOpen: h = !1
}) {
  const [w, u] = x(!1), [, v] = x(0), S = h || w;
  if (Y(() => {
    const i = setInterval(() => {
      v((D) => D + 1);
    }, 1e3);
    return () => {
      clearInterval(i);
    };
  }, []), !s)
    return null;
  let o;
  typeof s == "number" ? o = new Date(s < 1e10 ? s * 1e3 : s) : o = new Date(s);
  const c = o.toISOString(), g = o.toLocaleString(void 0, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short"
  }), O = P(o);
  return /* @__PURE__ */ n(
    "div",
    {
      className: m("relative inline-block", d),
      onMouseEnter: () => {
        u(!0);
      },
      onMouseLeave: () => {
        u(!1);
      },
      children: [
        /* @__PURE__ */ e(
          "time",
          {
            dateTime: c,
            className: "cursor-help border-b border-gray-400 dark:border-gray-400 text-gray-700 dark:text-gray-300",
            children: O
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: m(
              "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-[9999] w-72",
              "transition-all duration-200 ease-out origin-bottom",
              S ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-2 pointer-events-none"
            ),
            children: /* @__PURE__ */ e(
              J,
              {
                rounded: "lg",
                shadow: "lg",
                className: "p-3 text-xs !bg-white dark:!bg-gray-900 !backdrop-blur-none",
                children: /* @__PURE__ */ n("div", { className: "space-y-2.5", children: [
                  l !== void 0 && /* @__PURE__ */ n("div", { children: [
                    /* @__PURE__ */ e("div", { className: "text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400 font-semibold mb-0.5", children: "Raw Value" }),
                    /* @__PURE__ */ n("div", { className: "flex items-center gap-1", children: [
                      /* @__PURE__ */ e("span", { className: "font-mono text-gray-700 dark:text-gray-200 break-all leading-tight", children: typeof l == "object" ? JSON.stringify(l) : String(l) }),
                      /* @__PURE__ */ e(
                        F,
                        {
                          value: typeof l == "object" ? JSON.stringify(l) : String(l)
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ n("div", { children: [
                    /* @__PURE__ */ e("div", { className: "text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400 font-semibold mb-0.5", children: "UTC ISO" }),
                    /* @__PURE__ */ n("div", { className: "flex items-center gap-1", children: [
                      /* @__PURE__ */ e("span", { className: "font-mono text-gray-700 dark:text-gray-200 break-all leading-tight", children: c }),
                      /* @__PURE__ */ e(F, { value: c })
                    ] })
                  ] }),
                  /* @__PURE__ */ n("div", { children: [
                    /* @__PURE__ */ e("div", { className: "text-[10px] uppercase tracking-wider text-gray-500 dark:text-gray-400 font-semibold mb-0.5", children: "Local Time" }),
                    /* @__PURE__ */ n("div", { className: "flex items-center gap-1", children: [
                      /* @__PURE__ */ e("span", { className: "text-gray-700 dark:text-gray-200 leading-tight", children: g }),
                      /* @__PURE__ */ e(F, { value: g })
                    ] })
                  ] })
                ] })
              }
            )
          }
        )
      ]
    }
  );
}
function te(s) {
  return s < 1e3 ? `${s.toFixed(2)}ms` : `${(s / 1e3).toFixed(2)}s`;
}
function re(s) {
  return typeof s != "string" ? !1 : [
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/,
    // ISO format
    /^\d{4}-\d{2}-\d{2}$/
    // Date only
  ].some((l) => l.test(s));
}
function ae(s) {
  const d = s.toLowerCase();
  return !!(d.includes("created") || d.includes("date") || d.includes("updated") || s.endsWith("At") || d.endsWith("_at"));
}
function le(s, d) {
  for (const l of d) {
    const h = l[s];
    if (h != null)
      return typeof h == "boolean" ? "bool" : typeof h == "number" && ae(s) ? "date" : typeof h == "number" ? "number" : re(h) ? "date" : "string";
  }
  return "string";
}
function de({
  results: s,
  meta: d,
  columns: l,
  error: h,
  title: w = "Results",
  pageSize: u = 25,
  onExportCsv: v,
  onExportJson: S,
  serverPagination: o
}) {
  const c = s ?? [], [g, O] = x(""), [i, D] = x(null), [f, L] = x(/* @__PURE__ */ new Set()), [b, M] = x(1), $ = !!o, N = o ? Math.floor(o.offset / o.limit) + 1 : 1, k = o ? Math.ceil(o.total / o.limit) : 1, R = T(() => l || (c.length === 0 ? [] : Object.keys(c[0]).map((r) => ({
    key: r,
    label: r,
    type: le(r, c)
  }))), [l, c]), I = T(() => g ? c.filter(
    (r) => Object.values(r).some(
      (a) => String(a).toLowerCase().includes(g.toLowerCase())
    )
  ) : c, [c, g]), j = T(() => i ? [...I].sort((r, a) => {
    const t = r[i.key], C = a[i.key];
    return t == null ? 1 : C == null ? -1 : t < C ? i.direction === "asc" ? -1 : 1 : t > C ? i.direction === "asc" ? 1 : -1 : 0;
  }) : I, [I, i]), y = Math.ceil(j.length / u), p = T(() => {
    const r = (b - 1) * u;
    return j.slice(r, r + u);
  }, [j, b, u]);
  T(() => {
    M(1);
  }, [g, i]);
  const U = (r) => {
    D((a) => (a == null ? void 0 : a.key) === r ? a.direction === "asc" ? { key: r, direction: "desc" } : null : { key: r, direction: "asc" });
  }, E = () => {
    f.size === p.length ? L(/* @__PURE__ */ new Set()) : L(new Set(p.map((r, a) => a)));
  }, G = (r) => {
    const a = new Set(f);
    a.has(r) ? a.delete(r) : a.add(r), L(a);
  }, H = (r, a) => {
    const t = r[a.key];
    if (t == null)
      return /* @__PURE__ */ e("span", { className: "text-xs italic dark:text-gray-600 text-gray-400", children: "NULL" });
    switch (a.type ?? "string") {
      case "bool":
        return t === !0 ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center w-6 h-6 rounded-full dark:bg-white/[0.06] bg-black/[0.04] dark:text-gray-300 text-gray-700", children: /* @__PURE__ */ e(z, { className: "w-3.5 h-3.5" }) }) : /* @__PURE__ */ e("div", { className: "flex items-center justify-center w-6 h-6 rounded-full dark:bg-white/[0.06] bg-black/[0.04] dark:text-gray-300 text-gray-700", children: /* @__PURE__ */ e(V, { className: "w-3.5 h-3.5" }) });
      case "date":
        return /* @__PURE__ */ e(
          ee,
          {
            timestamp: t,
            rawValue: typeof t == "number" ? t : void 0
          }
        );
      case "number":
        return /* @__PURE__ */ e("span", { className: "text-sm font-mono dark:text-gray-300 text-gray-700", children: typeof t == "number" ? t.toLocaleString() : JSON.stringify(t) });
      default:
        return typeof t == "object" ? /* @__PURE__ */ e("span", { className: "text-sm font-mono dark:text-gray-300 text-gray-700", children: JSON.stringify(t) }) : /* @__PURE__ */ e("span", { className: "text-sm dark:text-gray-300 text-gray-700", children: typeof t == "object" ? JSON.stringify(t) : String(t) });
    }
  };
  return h ? /* @__PURE__ */ n(
    J,
    {
      rounded: "2xl",
      shadow: "lg",
      className: "border-red-500/30 dark:border-red-500/20",
      children: [
        /* @__PURE__ */ e("div", { className: "p-5 border-b dark:border-white/[0.08] border-gray-200", children: /* @__PURE__ */ e("h2", { className: "text-lg font-semibold text-red-500", children: "Query Error" }) }),
        /* @__PURE__ */ e("div", { className: "p-5", children: /* @__PURE__ */ e("p", { className: "font-mono text-sm text-red-500", children: h }) })
      ]
    }
  ) : /* @__PURE__ */ n(J, { rounded: "2xl", shadow: "lg", className: "flex flex-col", children: [
    /* @__PURE__ */ n("div", { className: "p-5 border-b dark:border-white/[0.08] border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4", children: [
      /* @__PURE__ */ n("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ e("h2", { className: "text-lg font-semibold dark:text-white text-gray-900", children: w }),
        d && /* @__PURE__ */ e("span", { className: "px-2 py-0.5 rounded-full text-xs font-medium bg-green-500/10 text-green-600 dark:text-green-400 border border-green-500/20", children: te(d.duration) }),
        /* @__PURE__ */ n("span", { className: "text-sm dark:text-gray-500 text-gray-500", children: [
          c.length,
          " row",
          c.length !== 1 ? "s" : ""
        ] })
      ] }),
      /* @__PURE__ */ n("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ n("div", { className: "relative group", children: [
          /* @__PURE__ */ e(q, { className: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 group-focus-within:text-blue-500 transition-colors" }),
          /* @__PURE__ */ e(
            "input",
            {
              type: "text",
              placeholder: "Search results...",
              value: g,
              onChange: (r) => {
                O(r.target.value);
              },
              className: "pl-9 pr-4 py-2 rounded-lg text-sm bg-gray-100 dark:bg-white/[0.06] border border-transparent focus:bg-white dark:focus:bg-black focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all w-full sm:w-64 dark:text-white text-gray-900 placeholder-gray-500"
            }
          )
        ] }),
        (v ?? S) && /* @__PURE__ */ n("div", { className: "flex items-center gap-2 border-l dark:border-white/[0.08] border-gray-200 pl-3 ml-1", children: [
          v && /* @__PURE__ */ e(
            "button",
            {
              onClick: v,
              className: "p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-white/[0.06] text-gray-500 dark:text-gray-400 transition-colors",
              title: "Export CSV",
              children: /* @__PURE__ */ e(B, { className: "w-4 h-4" })
            }
          ),
          S && /* @__PURE__ */ e(
            "button",
            {
              onClick: S,
              className: "p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-white/[0.06] text-gray-500 dark:text-gray-400 transition-colors",
              title: "Export JSON",
              children: /* @__PURE__ */ e(X, { className: "w-4 h-4" })
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "overflow-x-auto overflow-y-visible", children: /* @__PURE__ */ n("table", { className: "w-full text-left border-collapse font-mono", children: [
      /* @__PURE__ */ e("thead", { children: /* @__PURE__ */ n("tr", { className: "border-b dark:border-white/[0.08] border-gray-200 bg-gray-50/50 dark:bg-white/[0.02]", children: [
        /* @__PURE__ */ e("th", { className: "p-4 w-12", children: /* @__PURE__ */ e(
          "input",
          {
            type: "checkbox",
            checked: f.size === p.length && p.length > 0,
            onChange: E,
            className: "rounded border-gray-300 text-blue-600 focus:ring-blue-500 bg-transparent"
          }
        ) }),
        R.map((r) => /* @__PURE__ */ e(
          "th",
          {
            className: "p-4 text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 cursor-pointer hover:text-blue-500 dark:hover:text-blue-400 transition-colors select-none group",
            onClick: () => {
              U(r.key);
            },
            children: /* @__PURE__ */ n("div", { className: "flex items-center gap-1", children: [
              r.label,
              /* @__PURE__ */ n(
                "div",
                {
                  className: m(
                    "flex flex-col opacity-0 group-hover:opacity-50",
                    (i == null ? void 0 : i.key) === r.key && "opacity-100"
                  ),
                  children: [
                    /* @__PURE__ */ e(
                      Z,
                      {
                        className: m(
                          "w-2 h-2",
                          (i == null ? void 0 : i.key) === r.key && i.direction === "asc" && "text-blue-500"
                        )
                      }
                    ),
                    /* @__PURE__ */ e(
                      K,
                      {
                        className: m(
                          "w-2 h-2",
                          (i == null ? void 0 : i.key) === r.key && i.direction === "desc" && "text-blue-500"
                        )
                      }
                    )
                  ]
                }
              )
            ] })
          },
          r.key
        ))
      ] }) }),
      /* @__PURE__ */ e("tbody", { className: "divide-y dark:divide-white/[0.04] divide-gray-100", children: p.length > 0 ? p.map((r, a) => /* @__PURE__ */ n(
        "tr",
        {
          className: m(
            "group transition-colors",
            f.has(a) ? "bg-blue-50/50 dark:bg-blue-500/10" : "hover:bg-gray-50 dark:hover:bg-white/[0.02]"
          ),
          children: [
            /* @__PURE__ */ e("td", { className: "p-4", children: /* @__PURE__ */ e(
              "input",
              {
                type: "checkbox",
                checked: f.has(a),
                onChange: () => {
                  G(a);
                },
                className: "rounded border-gray-300 text-blue-600 focus:ring-blue-500 bg-transparent"
              }
            ) }),
            R.map((t) => /* @__PURE__ */ e(
              "td",
              {
                className: "p-4 whitespace-nowrap",
                children: H(r, t)
              },
              `${String(a)}-${t.key}`
            ))
          ]
        },
        a
      )) : /* @__PURE__ */ e("tr", { children: /* @__PURE__ */ e(
        "td",
        {
          colSpan: R.length + 1,
          className: "p-8 text-center text-gray-500 dark:text-gray-400",
          children: g ? `No results found matching "${g}"` : "Query executed successfully. No rows returned."
        }
      ) }) })
    ] }) }),
    /* @__PURE__ */ n("div", { className: "p-4 border-t dark:border-white/[0.08] border-gray-200 flex items-center justify-between text-xs text-gray-500 dark:text-gray-400", children: [
      /* @__PURE__ */ n("div", { children: [
        $ ? /* @__PURE__ */ n(A, { children: [
          "Showing",
          " ",
          /* @__PURE__ */ e("span", { className: "font-medium dark:text-white text-gray-900", children: o.offset + 1 }),
          "-",
          /* @__PURE__ */ e("span", { className: "font-medium dark:text-white text-gray-900", children: Math.min(
            o.offset + c.length,
            o.total
          ) }),
          " ",
          "of",
          " ",
          /* @__PURE__ */ e("span", { className: "font-medium dark:text-white text-gray-900", children: o.total }),
          " ",
          "total"
        ] }) : /* @__PURE__ */ n(A, { children: [
          "Showing",
          " ",
          /* @__PURE__ */ e("span", { className: "font-medium dark:text-white text-gray-900", children: p.length }),
          " ",
          "of",
          " ",
          /* @__PURE__ */ e("span", { className: "font-medium dark:text-white text-gray-900", children: j.length }),
          " ",
          "results"
        ] }),
        f.size > 0 && /* @__PURE__ */ n("span", { className: "ml-3 text-blue-500 font-medium", children: [
          f.size,
          " row",
          f.size !== 1 ? "s" : "",
          " ",
          "selected"
        ] })
      ] }),
      $ && k > 1 && /* @__PURE__ */ n("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => {
              o.onPageChange(
                Math.max(0, o.offset - o.limit)
              );
            },
            disabled: N === 1,
            className: "p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-white/[0.06] disabled:opacity-30 disabled:cursor-not-allowed transition-colors",
            children: /* @__PURE__ */ e(Q, { className: "w-4 h-4" })
          }
        ),
        /* @__PURE__ */ e("div", { className: "flex items-center gap-1", children: Array.from({ length: Math.min(k, 5) }, (r, a) => {
          let t;
          return k <= 5 || N <= 3 ? t = a + 1 : N >= k - 2 ? t = k - 4 + a : t = N - 2 + a, /* @__PURE__ */ e(
            "button",
            {
              onClick: () => {
                o.onPageChange(
                  (t - 1) * o.limit
                );
              },
              className: m(
                "px-2.5 py-1 rounded-lg font-medium transition-colors",
                N === t ? "bg-blue-500/10 text-blue-600 dark:text-blue-400" : "hover:bg-gray-100 dark:hover:bg-white/[0.06]"
              ),
              children: t
            },
            t
          );
        }) }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => {
              o.onPageChange(
                o.offset + o.limit
              );
            },
            disabled: N === k,
            className: "p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-white/[0.06] disabled:opacity-30 disabled:cursor-not-allowed transition-colors",
            children: /* @__PURE__ */ e(_, { className: "w-4 h-4" })
          }
        )
      ] }),
      !$ && y > 1 && /* @__PURE__ */ n("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => {
              M((r) => Math.max(1, r - 1));
            },
            disabled: b === 1,
            className: "p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-white/[0.06] disabled:opacity-30 disabled:cursor-not-allowed transition-colors",
            children: /* @__PURE__ */ e(Q, { className: "w-4 h-4" })
          }
        ),
        /* @__PURE__ */ e("div", { className: "flex items-center gap-1", children: Array.from({ length: Math.min(y, 5) }, (r, a) => {
          let t;
          return y <= 5 || b <= 3 ? t = a + 1 : b >= y - 2 ? t = y - 4 + a : t = b - 2 + a, /* @__PURE__ */ e(
            "button",
            {
              onClick: () => {
                M(t);
              },
              className: m(
                "px-2.5 py-1 rounded-lg font-medium transition-colors",
                b === t ? "bg-blue-500/10 text-blue-600 dark:text-blue-400" : "hover:bg-gray-100 dark:hover:bg-white/[0.06]"
              ),
              children: t
            },
            t
          );
        }) }),
        /* @__PURE__ */ e(
          "button",
          {
            onClick: () => {
              M((r) => Math.min(y, r + 1));
            },
            disabled: b === y,
            className: "p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-white/[0.06] disabled:opacity-30 disabled:cursor-not-allowed transition-colors",
            children: /* @__PURE__ */ e(_, { className: "w-4 h-4" })
          }
        )
      ] })
    ] })
  ] });
}
export {
  de as S,
  ee as T
};
